class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


if (!window.wbCartSubscriptionUpsellInitialized) {
  window.wbCartSubscriptionUpsellInitialized = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wb-convert-to-subscription]');
    if (!button) return;

    event.preventDefault();

    const upsell = button.closest('[data-wb-cart-subscription-upsell]');
    const select = upsell?.querySelector('[data-wb-selling-plan-select]');
    const status = upsell?.querySelector('[data-wb-subscription-status]');
    const cartDrawer = document.querySelector('cart-drawer');
    const cartItems = button.closest('cart-items');
    const sellingPlanId = select?.value;
    const lineKey = button.dataset.lineKey;
    const quantity = parseInt(button.dataset.quantity || '1', 10);
    const renderCartPage = Boolean(cartItems?.getSectionsToRender);

    if (!sellingPlanId || !lineKey || (!cartDrawer && !renderCartPage)) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.classList.add('loading');
    button.textContent = 'Updating...';
    if (status) status.textContent = '';

    const sections = renderCartPage
      ? cartItems.getSectionsToRender().map((section) => section.section)
      : cartDrawer.getSectionsToRender().map((section) => section.id);
    const body = JSON.stringify({
      id: lineKey,
      quantity,
      selling_plan: sellingPlanId,
      sections,
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then((state) => {
        if (state.errors) throw new Error(state.errors);

        CartPerformance.measure('subscription-upsell:paint-updated-sections', () => {
          if (renderCartPage) {
            const cartFooter = document.getElementById('main-cart-footer');

            cartItems.classList.toggle('is-empty', state.item_count === 0);
            if (cartFooter) cartFooter.classList.toggle('is-empty', state.item_count === 0);
            if (cartDrawer) cartDrawer.classList.toggle('is-empty', state.item_count === 0);

            cartItems.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
              elementToReplace.innerHTML = cartItems.getSectionInnerHTML(state.sections[section.section], section.selector);
            });
          } else {
            if (!state.sections || !state.sections['cart-drawer']) throw new Error('Cart drawer could not be refreshed.');
            cartDrawer.renderContents({ ...state, sections: state.sections });
          }
        });

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'wb-subscription-upsell',
          cartData: state,
          variantId: null,
        });
      })
      .catch((error) => {
        console.error(error);
        button.disabled = false;
        button.classList.remove('loading');
        button.textContent = originalText;
        if (status) status.textContent = error.message || window.cartStrings?.error || 'Could not update subscription.';
      });
  });
}
